<template>
  <div>
    <slot />
    <div
      v-if="numPages > 0"
      class="page-selector"
    >
      <v-pagination
        :value="currentPage + 1"
        :length="numPages"
        :total-visible="7"
        @input="$emit('onPageChange', $event - 1)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    numPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.page-selector {
  padding: 8px 0;
}

::v-deep .v-pagination__item, ::v-deep .v-pagination__more {
  box-shadow: none !important;
  background: none !important;
  font-size: 14px;
  margin: 2px;
  height: 28px;
  min-width: 28px;
}

::v-deep .v-pagination__item.primary {
  background-color: #d6d7f2 !important;
  color: #3f47cd !important;
}

::v-deep .v-pagination__navigation {
  box-shadow: none !important;
  background: none !important;
  margin: 2px;
}

::v-deep .v-pagination__navigation .v-icon {
  font-size: 20px !important;
}
</style>
